"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaStore = void 0;
const client_utils_1 = require("@sensenet/client-utils");
/**
 * Class that stores schema information
 */
class SchemaStore {
    constructor() {
        this.schemas = new client_utils_1.ObservableValue([]);
        this.byNameSchemaCache = new Map();
    }
    subscribeToSchemas(callback) {
        return this.schemas.subscribe(callback);
    }
    /**
     * Updates the schema information in the store and inv
     */
    setSchemas(newSchemas) {
        this.byNameSchemaCache.clear();
        this.schemas.setValue(newSchemas);
    }
    mergeFieldSettings(currentFieldSettings, parentFieldSettings) {
        const currentFieldSettingsMap = new Map();
        currentFieldSettings.forEach((s) => currentFieldSettingsMap.set(s.Name, s));
        const parentFieldSettingsMap = new Map();
        parentFieldSettings.forEach((s) => parentFieldSettingsMap.set(s.Name, s));
        const keys = new Set([...currentFieldSettingsMap.keys(), ...parentFieldSettingsMap.keys()]);
        return Array.from(keys).map((key) => {
            return Object.assign(Object.assign({}, parentFieldSettingsMap.get(key)), currentFieldSettingsMap.get(key));
        });
    }
    /**
     * Returns the Content Type Schema for the provided content type name
     * @param {string} contentTypeName The name of the content type
     */
    getSchemaByName(contentTypeName) {
        if (this.byNameSchemaCache.has(contentTypeName)) {
            return Object.assign({}, this.byNameSchemaCache.get(contentTypeName));
        }
        const schema = this.schemas.getValue().find((s) => s.ContentTypeName === contentTypeName);
        if (!schema) {
            return this.getSchemaByName('GenericContent');
        }
        const parentSchema = schema.ParentTypeName && this.getSchemaByName(schema.ParentTypeName);
        if (parentSchema) {
            schema.FieldSettings = this.mergeFieldSettings(schema.FieldSettings, parentSchema.FieldSettings);
        }
        this.byNameSchemaCache.set(contentTypeName, schema);
        return schema;
    }
    /**
     * Returns the Field Type for the provided content field name
     * @param {string} fieldName The name of field you search for
     */
    getFieldTypeByName(fieldName) {
        const schemasCopy = [...this.schemas.getValue()];
        return schemasCopy.reduce((_, schema) => {
            var _a;
            const fieldType = (_a = schema.FieldSettings.find((fieldSetting) => fieldSetting.Name === fieldName)) === null || _a === void 0 ? void 0 : _a.Type;
            if (fieldType) {
                schemasCopy.length = 0;
            }
            return fieldType;
        }, undefined);
    }
    /**
     * Returns a boolean value that indicates if the specified content is an instance or descendant of a given content type
     * @param content The given content to check
     * @param contentTypeName The name of content type
     */
    isContentFromType(content, contentTypeName) {
        if (!content) {
            return false;
        }
        else if (content.Type === contentTypeName) {
            return true;
        }
        let currentSchema = this.getSchemaByName(content.Type);
        do {
            if (currentSchema.ContentTypeName === contentTypeName) {
                return true;
            }
            currentSchema = this.getSchemaByName(currentSchema.ParentTypeName || '');
        } while (currentSchema.ContentTypeName && currentSchema.ContentTypeName !== 'GenericContent');
        return contentTypeName === 'GenericContent';
    }
    /**
     * Returns if a given content type is a descendant of an another content type
     * @param child The child content name
     * @param parent The parent content name
     */
    schemaIsDescendantOf(child, parent) {
        let currentSchema = this.getSchemaByName(child);
        do {
            if (currentSchema.ContentTypeName === parent) {
                return true;
            }
            currentSchema = this.getSchemaByName(currentSchema.ParentTypeName || '');
        } while (currentSchema.ContentTypeName && currentSchema.ContentTypeName !== 'GenericContent');
        return parent === 'GenericContent';
    }
    /**
     * Returns a list of the content types existing on schema
     */
    getTypesFromSchema() {
        const schemasCopy = [...this.schemas.getValue()];
        const contentTypes = schemasCopy.map((schema) => schema.ContentTypeName.toString());
        return contentTypes;
    }
}
exports.SchemaStore = SchemaStore;
//# sourceMappingURL=SchemaStore.js.map